import StockDailyLedger from "@/pages/inventory/StockDailyLedger";
export default function RawDaily() {
  return <StockDailyLedger
    category="raw"
    title="Raw material — daily ledger"
    subtitle="Opening · IN · OUT · Consumption · Closing. Locked daily by Store Manager."
    ownerLabel="Store Manager"
    testid="raw-daily-page"
  />;
}
